import React from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button,
    Slide,
    Divider,
    IconButton
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const ConfirmDialog = ({ open, title, content, onCancel, onConfirm }) => {
    return (
        <Dialog
            open={open}
            onClose={onCancel}
            maxWidth="xs"
            fullWidth
            TransitionComponent={Transition}
            keepMounted
            style={{ zIndex: 1400 }}
            PaperProps={{
                style: {
                    borderRadius: 16,
                    padding: '8px 16px',
                    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.1)',
                    zIndex: 1401
                },
            }}
        >
            <DialogTitle
                style={{
                    fontWeight: 700,
                    fontSize: '1.25rem',
                    textAlign: 'center',
                    paddingBottom: 4,
                    color: '#333',
                    position: 'relative',
                }}
            >
                {title || 'Are you sure?'}
                <IconButton
                    onClick={onCancel}
                    style={{
                        position: 'absolute',
                        right: 0,
                        top: 0,
                        color: '#888',
                    }}
                    aria-label="close"
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <Divider style={{ margin: '0 24px 8px' }} />

            <DialogContent style={{ textAlign: 'center' }}>
                <DialogContentText style={{ fontSize: '1rem', color: '#555' }}>
                    {content || 'Do you want to proceed with this action?'}
                </DialogContentText>
            </DialogContent>

            <DialogActions style={{ justifyContent: 'center', paddingBottom: 20 }}>
                <Button
                    onClick={onCancel}
                    variant="outlined"
                    style={{
                        borderRadius: 8,
                        padding: '6px 20px',
                        textTransform: 'none',
                        fontWeight: 500,
                        color: '#555',
                        borderColor: '#ccc',
                        backgroundColor: '#f9f9f9',
                        transition: 'all 0.3s ease',
                    }}
                    onMouseOver={(e) => {
                        e.currentTarget.style.backgroundColor = '#eee';
                        e.currentTarget.style.borderColor = '#bbb';
                    }}
                    onMouseOut={(e) => {
                        e.currentTarget.style.backgroundColor = '#f9f9f9';
                        e.currentTarget.style.borderColor = '#ccc';
                    }}
                >
                    Cancel
                </Button>

                <Button
                    onClick={onConfirm}
                    variant="contained"
                    style={{
                        borderRadius: 8,
                        padding: '6px 20px',
                        textTransform: 'none',
                        fontWeight: 500,
                        backgroundColor: '#1e32da',
                        color: '#fff',
                        marginLeft: 12,
                        boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.15)',
                        transition: 'all 0.3s ease',
                    }}
                    onMouseOver={(e) => {
                        e.currentTarget.style.backgroundColor = '#1e32da';
                    }}
                    onMouseOut={(e) => {
                        e.currentTarget.style.backgroundColor = '#1e32da';
                    }}
                >
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;
